<template>
  <span class="kds-eyebrow">
    <slot />
  </span>
</template>

<script setup lang="ts">
// No props — pure typography primitive.
</script>

<style scoped lang="scss">
.kds-eyebrow {
  font-family: var(--font-mono);
  font-size: 11px;
  line-height: 1.4;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--stone);
}
</style>
